// frontend/src/pages/DashboardPage.js

// import React, { useState, useEffect, useCallback } from 'react';
// import { Box, Typography, Button, CircularProgress, Grid } from '@mui/material';
// import api from '../services/api';
// import DocumentCard from '../components/DocumentCard';

// const DashboardPage = () => {
//   const [pendingDocuments, setPendingDocuments] = useState([]);
//   const [completedDocuments, setCompletedDocuments] = useState([]);
//   const [completedPage, setCompletedPage] = useState(1);
//   const [hasMoreCompleted, setHasMoreCompleted] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [loadingMore, setLoadingMore] = useState(false);
//   const [error, setError] = useState('');

//   const fetchDocuments = useCallback(async (page = 1) => {
//     page === 1 ? setLoading(true) : setLoadingMore(true);
//     setError('');

//     try {
//       if (page === 1) {
//         // ### CORREÇÃO AQUI: Chamando a rota correta para o dashboard ###
//         const pendingResponse = await api.get('/documentos/?status=EM_COLETA');
//         setPendingDocuments(pendingResponse.data.results || (Array.isArray(pendingResponse.data) ? pendingResponse.data : []));
//       }

//       // ### CORREÇÃO AQUI: Chamando a rota correta para o dashboard ###
//       const completedResponse = await api.get(`/documentos/?status=CONCLUIDO&page=${page}`);
//       const newCompleted = completedResponse.data.results || [];

//       setCompletedDocuments(prev => 
//         page === 1 ? newCompleted : [...prev, ...newCompleted]
//       );

//       if (!completedResponse.data.next) {
//         setHasMoreCompleted(false);
//       }

//     } catch (err) {
//       setError('Falha ao carregar documentos. Verifique se está logado.');
//       console.error(err);
//     } finally {
//       setLoading(false);
//       setLoadingMore(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchDocuments(1);
//   }, [fetchDocuments]);

//   const handleLoadMore = () => {
//     const nextPage = completedPage + 1;
//     setCompletedPage(nextPage);
//     fetchDocuments(nextPage);
//   };

//   if (loading) {
//     return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
//   }

//   if (error) {
//     return <Typography color="error" sx={{ p: 3 }}>{error}</Typography>;
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h4" gutterBottom>Meus Pedidos de Assinatura</Typography>
      
//       <Typography variant="h5" sx={{ mt: 2, mb: 2, borderBottom: 1, borderColor: 'divider', pb: 1 }}>Pendentes</Typography>
//       {pendingDocuments.length > 0 ? (
//         // ### SINTAXE DO GRID CORRIGIDA ###
//         <Grid container spacing={3}>
//         {pendingDocuments.map(doc => (
//           // A sintaxe correta é aplicar 'xs', 'sm', 'md' diretamente no Grid filho
//           <Grid xs={12} sm={6} md={4} key={doc.id}>
//             <DocumentCard document={doc} />
//           </Grid>
//         ))}
//       </Grid>
//       ) : (
//         <Typography>Nenhum documento pendente.</Typography>
//       )}

//       <Typography variant="h5" sx={{ mt: 4, mb: 2, borderBottom: 1, borderColor: 'divider', pb: 1 }}>Concluídos</Typography>
//       {completedDocuments.length > 0 ? (
//         // ### SINTAXE DO GRID CORRIGIDA ###
//         <Grid container spacing={3}>
//           {completedDocuments.map(doc => (
//             <Grid xs={12} sm={6} md={4} key={doc.id}>
//               <DocumentCard document={doc} />
//             </Grid>
//           ))}
//         </Grid>
//       ) : (
//         <Typography>Nenhum documento concluído.</Typography>
//       )}

//       {hasMoreCompleted && (
//         <Box sx={{ textAlign: 'center', mt: 4 }}>
//           <Button variant="outlined" onClick={handleLoadMore} disabled={loadingMore}>
//             {loadingMore ? 'Carregando...' : 'Carregar Mais'}
//           </Button>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default DashboardPage;

import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from 'react-router-dom'; 
import DocumentList from '../components/DocumentList';
// import NewDocumentModal from '../components/NewDocumentModal';
import { getOperatorDocuments } from '../services/api';

const DashboardPage = () => {
  const navigate = useNavigate();
  
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchDocuments = useCallback(async () => {
    try {
      setIsLoading(true);
      setError('');
      const response = await getOperatorDocuments();
      setDocuments(response.data);
    } catch (err) {
      setError('Falha ao carregar os documentos. Tente novamente.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  const handleDeleteDocument = useCallback((deletedId) => {
    setDocuments((prev) => prev.filter((doc) => doc.id !== deletedId));
  }, []);
  
  // const handleModalSuccess = () => {
  //   setModalOpen(false);
  //   fetchDocuments(); 
  // };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Meus Pedidos de Assinatura
        </Typography>
        <Box>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={fetchDocuments}
            disabled={isLoading}
            sx={{ mr: 2 }}
          >
            {isLoading ? 'Atualizando...' : 'Atualizar'}
          </Button>
          {/* --- BOTÃO AGORA FUNCIONAL --- */}
          <Button
            variant="contained"
            startIcon={<AddCircleOutlineIcon />}
            onClick={() => navigate('/novo-pedido')} 
          >
            Novo Pedido
          </Button>
        </Box>
      </Box>

      {error && <Typography color="error">{error}</Typography>}
      
      <DocumentList documents={documents} isLoading={isLoading} onDelete={handleDeleteDocument} />
      
      {/* --- MODAL SENDO CONTROLADO PELO ESTADO LOCAL --- */}
      {/* <NewDocumentModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSuccess={handleModalSuccess}
      /> */}
    </Box>
  );
};

export default DashboardPage;